// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"8a48b7a9205de903","685":"2194b9596ea5cfc3","775":"b465b6681c0e9150"}[chunkId] + ".js";
};